module.exports = __webpack_public_path__ + "static/media/accesorios-01.ddffbe96.png";